import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import './FormPageWrapper.sass';

export const FormPageWrapper = ({ children, className }) => {
  const classes = classnames('form-page-wrapper', {
    [className]: className,
  });
  return <div className={classes}>{children}</div>;
};

FormPageWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

FormPageWrapper.defaultProps = {
  children: null,
  className: '',
};
